// extracted by mini-css-extract-plugin
export var container = "_2f-0";
export var disabled = "_2f-4";
export var fullWidth = "_2f-3";
export var lined = "_2f-1";
export var selected = "_2f-5";
export var tab = "_2f-2";